//https://www.gruppocap.it/content/groupcap/it.SERPSearchServlet.json?query=prova&language=it

export const suggestURL = (domain,language, value) => {
  return (`${domain}/content/groupcap/it.SERPSearchServlet.json?query=${value}&language=${selectedLanguage(language)}`);
};

export const searchURL = (domain, language, value) => {
  return `${domain}/${selectedLanguage(language) === 'it'?selectedLanguage(language)+'/ricerca':selectedLanguage(language)+'/search'}?query=${value}`
};

const selectedLanguage = (language) => {
  if (language === "en-EN") {
    return "en";
  } else {
    return "it";
  }
};
